<div class="container-fluid mt-3">
  <div class="row no-gutters">
    <div class="col-3 bold px-1 pl-5 name-header">Name</div>
    <div class="col-5 bold px-1">Resource Types</div>

    <div
      class="col-2 offset-2 d-flex flex-nowrap justify-content-end align-items-center"
    >
      <!-- <button mat-icon-button (click)="addNew()">
        <mat-icon class="yellow">add_box</mat-icon>
      </button> -->
    </div>
  </div>
  <div
    cdkDropList
    cdkDropListLockAxis="y"
    (cdkDropListDropped)="drop($event)"
    [cdkDropListDisabled]="true"
  >
    <div *ngFor="let s of resourceTypesSettings">
      <div class="row no-gutters setting-row" cdkDrag [cdkDragDisabled]="true">
        <div class="col-3 px-1 d-flex">
          <mat-icon
            class="grey m-2 drag-handle"
            cdkDragHandle
            [cdkDragHandleDisabled]="true"
            >reorder</mat-icon
          >
          <mat-form-field
            appearance="outline"
            class="no-subscript"
            [ngClass]="{ deleted: s.id < 0 }"
          >
            <input
              matInput
              [(ngModel)]="s.name"
              [disabled]="s.disabled"
              [placeholder]="s.name ? '' : 'Enter a Name'"
            />
          </mat-form-field>
        </div>
        <div class="col-5 px-1">
          <mat-form-field
            class="resource-types no-subscript"
            [ngClass]="{ deleted: s.id < 0 }"
          >
            <mat-chip-grid
              #chipGrid
              aria-label="Selected resource type"
              [disabled]="s.disabled"
            >
              <!-- Show the selected ResourceType as a chip -->
              <span *ngIf="s?.resourceTypes?.length">
                <mat-chip-row *ngFor="let resourceType of s.resourceTypes">
                  {{ resourceType.name }}
                  <button
                    matChipRemove
                    aria-label="Remove ResourceType"
                    *ngIf="!s.disabled"
                    (click)="remove(s, resourceType)"
                  >
                    <mat-icon>cancel</mat-icon>
                  </button>
                </mat-chip-row>
              </span>

              <!-- The input stays inside the chip grid and drives the autocomplete -->
              <input
                #resourceTypeInput
                [disabled]="s?.disabled ?? false"
                [matAutocomplete]="auto"
                [matChipInputFor]="chipGrid"
                [matChipInputSeparatorKeyCodes]="[]"
                [matChipInputAddOnBlur]="false"
                (input)="filterResourceTypes($event)"
                [(ngModel)]="resourceTypeQuery"
                (keydown.backspace)="
                  resourceTypeQuery &&
                    remove(s, s.resourceTypes![s.resourceTypes!.length - 1])
                "
                [disabled]="s.disabled"
                [placeholder]="s.resourceTypes ? '' : 'Select a Resource Type'"
              />
            </mat-chip-grid>

            <mat-autocomplete
              #auto="matAutocomplete"
              [displayWith]="displayObject"
              (optionSelected)="onResourceTypeSelected(s, $event)"
              autoActiveFirstOption
            >
              <mat-option
                *ngFor="let resourceType of resourceTypesFiltered"
                [value]="resourceType"
              >
                {{ resourceType.name }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </div>

        <div class="col-2 offset-2 d-flex flex-nowrap justify-content-end">
          <div
            [ngClass]="{ 'row-buttons': s.disabled && s.id > 0 && !s.changed }"
          >
            <button
              matTooltip="Edit"
              mat-icon-button
              (click)="
                tmpResourceTypeSetting = utils.cloneDeep(s); s.disabled = false
              "
              *ngIf="s.disabled && s.id >= 0"
            >
              <mat-icon class="yellow">edit</mat-icon>
            </button>
            <button
              matTooltip="Accept"
              mat-icon-button
              [disabled]="!s.name && !s.resourceTypes?.length"
              (click)="save(); s.disabled = true"
              *ngIf="!s.disabled && s.id >= 0"
            >
              <mat-icon
                class="green"
                [ngClass]="{ gray: !s.name && !s.resourceTypes?.length }"
                >check_circle</mat-icon
              >
            </button>
            <button
              matTooltip="Cancel"
              mat-icon-button
              (click)="cancel(s)"
              *ngIf="!s.disabled && s.id >= 0"
            >
              <mat-icon class="red">cancel</mat-icon>
            </button>
            <button
              [disabled]="true"
              matTooltip="Delete"
              mat-icon-button
              (click)="s.id = -s.id; save()"
              *ngIf="s.disabled && s.id >= 0"
            >
              <mat-icon class="grey">delete</mat-icon>
            </button>
            <button
              mat-icon-button
              (click)="s.id = -s.id; save()"
              *ngIf="s.disabled && s.id < 0"
            >
              <mat-icon
                matTooltip="Undelete"
                class="blue material-symbols-outlined"
                >restore_from_trash</mat-icon
              >
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
